import React from 'react'
import '../../styles/TodosError.css'

export default function TodosError() {
  return (
    <p>error...</p>
  )
}


export { TodosError }